import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import SpriteComponent from '../../../Component/Render/Sprite';
import Renderable from '../../../Component/Renderable';
import UINineSliceComponent from '../../../Component/Render/NineSlice';
import { delay } from '../../../Utility/Task/TaskQueue';
import TransformComponent from 'Component/Transform';

interface IProgressBarSlideMotionData {
    duration: number;
    delay: number;
    progressBarFillMaxWidth: number;
}

export class ProgressBarSlideMotion extends AnimationClip<
    IProgressBarSlideMotionData
> {
    public *execute(
        gameObject: GameObject,
        meta?: IProgressBarSlideMotionData
    ): IterableIterator<number> {
        let renderable: any;
        renderable =
            gameObject.getComponent(SpriteComponent) ??
            gameObject.getComponent(Renderable);
        const transform = gameObject.getComponent(UINineSliceComponent) ||
            gameObject.getComponent(TransformComponent);
            
        transform.width = meta.progressBarFillMaxWidth;
        renderable.visible = true;

        const slideTween = this.getTween(transform);
        const alphaTween = this.getTween(renderable).to(
            { alpha: 1 },
            meta.delay / 2
        );

        slideTween.to({ width: 0 }, meta.duration).easing(Easing.Linear.None);

        // Loop.
        while (true) {
            yield* this.startTween(slideTween);
            yield* delay(meta.delay / 2);
            renderable.alpha = 0;
            transform.width = meta.progressBarFillMaxWidth;
            yield* this.startTween(alphaTween);
        }
    }
}
